import type { ValidationErrors } from '../../../../../utils/validation';
import { NullableInputText } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroup } from '../../../../elements/forms/HorizontalFormGroup';

interface IBloeddrukCustomControlData {
    bloeddruk_diastolisch: string | null;
    bloeddruk_systolisch: string | null;
}

interface IBloeddrukAddEditProps {
    automation?: string;
    customControlData: IBloeddrukCustomControlData;
    errors: ValidationErrors;
    handleChange: (customControlData: Partial<IBloeddrukCustomControlData>) => Promise<void>;
    isRequired?: boolean;
    validateOne: (name: keyof IBloeddrukCustomControlData) => Promise<void>;
}

export function BloeddrukAddEdit(props: IBloeddrukAddEditProps) {
    return (
        <>
            <HorizontalFormGroup hasErrors={props.errors.has('customControlData.bloeddruk_systolisch')}>
                <FormLabel isRequired={props.isRequired}>Bloeddruk systolisch</FormLabel>
                <div className="col-4">
                    <NullableInputText
                        automation={props.automation ? `${props.automation}-systolisch` : undefined}
                        descriptionText="mmHg"
                        error={props.errors.get('customControlData.bloeddruk_systolisch')}
                        onChange={async (value) => await props.handleChange({ bloeddruk_systolisch: value })}
                        onDoValidate={async () => await props.validateOne('bloeddruk_systolisch')}
                        value={props.customControlData.bloeddruk_systolisch}
                    />
                </div>
            </HorizontalFormGroup>

            <HorizontalFormGroup hasErrors={props.errors.has('customControlData.bloeddruk_diastolisch')}>
                <FormLabel isRequired={props.isRequired}>Bloeddruk diastolisch</FormLabel>
                <div className="col-4">
                    <NullableInputText
                        automation={props.automation ? `${props.automation}-diastolisch` : undefined}
                        descriptionText="mmHg"
                        error={props.errors.get('customControlData.bloeddruk_diastolisch')}
                        onChange={async (value) => await props.handleChange({ bloeddruk_diastolisch: value })}
                        onDoValidate={async () => await props.validateOne('bloeddruk_diastolisch')}
                        value={props.customControlData.bloeddruk_diastolisch}
                    />
                </div>
            </HorizontalFormGroup>
        </>
    );
}
